import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { CoverageRuleAction } from '@cbridge-packages/coverage-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdateCoverageRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.update.done),
  // Apply the errors/warnings the backend reported for the saved rule set, then exit editing.
  mergeMap((payload) => [
    RulesManagementAction.applyValidation(payload.result),
    RulesManagementAction.endEditing(undefined),
  ]),
);
